import React, { useEffect, useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import ToolTipWrapper from '../Tooltip/ToolTipWrapper';

import { IHttpRequest } from "@/interfaces/IHttp";
import { LockerHighlightsResponse } from  '@/interfaces/LockerManagement'
import { container, TYPES } from "@/inversifyconfig/container.config";
import { IconLibrary, ThriveIcon } from 'thrive-components';


const LockerHighlights = () => {
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    const [lockerHighlightsValues, setLockerHighlightsValues] = useState<LockerHighlightsResponse>({filesReceived: 0, uniqueOpens: 0, filesSuccessfullySent: 0, failures: 0})

    useEffect(() => {
        httpCall.get('locker/batches/highlights')
            .then(({data}:{data: LockerHighlightsResponse}) => {
                setLockerHighlightsValues(data)
            })
            .catch((e)=> {
               console.error("Locker Highlights Error: ", e);
            })
    }, []);

    function HighlightDetail ({value, label, iconName, colour}:{value: string | number, label: string, iconName: IconLibrary, colour: string}): JSX.Element {
        return (
            <div className="highlight-cell">
                <span className="highlight-cell-value">{Intl.NumberFormat().format(+value)}</span>
                <div className="label-wrapper">
                    <ThriveIcon 
                        iconName={iconName}
                        sizeInPx='16'
                        color={colour}    
                    />
                    <p className="highlight-cell-label">{label}</p>
                </div>
            </div>
        )
    }

    const {filesReceived, filesSuccessfullySent, failures} = lockerHighlightsValues

    return (
        <>
            <div className="highlights-header">
                <h2 className='h-header'>Highlights this week</h2>
                <ToolTipWrapper id="highlight-tooltip-2" className="tracks-side-tooltip">
                    <ReactTooltip id="highlight-tooltip-2" place="top" className='thrive-tooltip' delayHide={1000} >
                        <span>Weekly statistics showing key information from the current week</span>
                    </ReactTooltip>
                </ToolTipWrapper>
            </div>
            <div className="highlight-grid">
                <HighlightDetail value={filesReceived} label="Files Sent" iconName={IconLibrary.LIST_ITEM} colour='var(--thriveGreyDark)'/>
                <HighlightDetail value={filesSuccessfullySent} label="Successfully Sent" iconName={IconLibrary.CHECK} colour='var(--thriveCheckbox)'/>
                <HighlightDetail value={failures} label="Failures" iconName={IconLibrary.CIRCLE_CLOSE} colour='var(--thriveRed)'/>
            </div>
        </>
)}

export default LockerHighlights